import React, { useEffect } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { usePermisos } from "../../context/PermisosContext";
import Error403 from "../../containers/errors/error403";

export default function RequireModulo({ modulo, accion, children }) {
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || localStorage.getItem("tokenadmin");
  const { perm, loaded } = usePermisos() || { perm: () => true, loaded: true };

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
    }
  }, [token, navigate]);

  // Sin token → no renderizar nada mientras se dispara el redirect
  if (!token) return null;

  // Permisos aún cargando → spinner
  if (!loaded) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  // Sin acceso al módulo, o sin la acción específica requerida por esta ruta
  // (consultar para detalle, insertar para crear, editar para editar) → 403
  if (!perm(modulo, "modulo") || (accion && !perm(modulo, accion))) {
    return <Error403 />;
  }

  return children;
}
